import {
    BASIC_COMPOSITION_TYPE,
    INIT_PARENT_BASIC_COMPOSITION,
} from "@constants";
import { produce } from "immer";

// eslint-disable-next-line
export function refactorBasicCompInShopcart(orderItems: OrderItem[]): any {
    return orderItems.map((product: OrderItem) => {
        if (
            product.haveBasicComposition &&
            !product.shopCart[BASIC_COMPOSITION_TYPE] &&
            product.isHiddenBasicComp
        ) {
            if (Object.keys(product.shopCart).length > 0) {
                const firstKeyShoCart = Object.keys(product.shopCart)[0];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const firstItemShopCart: any = Object.values(
                    product.shopCart[firstKeyShoCart].compositions
                )[0];
                const workflowBasicComposition = produce(
                    firstItemShopCart?.workflow,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (draft: any) => {
                        const lastIndex = draft.length - 1;
                        if (
                            !Object.getOwnPropertyDescriptor(
                                draft[lastIndex],
                                "index"
                            )?.writable
                        ) {
                            draft[lastIndex] = {
                                ...draft[lastIndex],
                                index: 0,
                            };
                        } else {
                            draft[lastIndex].index = 0;
                        }
                    }
                );

                return {
                    ...product,
                    shopCart: {
                        ...product.shopCart,
                        [BASIC_COMPOSITION_TYPE]: {
                            ...INIT_PARENT_BASIC_COMPOSITION,
                            workflow: workflowBasicComposition,
                        },
                    },
                };
            }
        }
        return product;
    });
}
